import { GRAPHQL_ENDPOINT, SITE } from "@api/constants";

type RequestProps = {
  query: string;
  token?: string;
  variables?: Record<string, any>;
};

export const request = ({ query, token, variables = {} }: RequestProps): Promise<Response> => {
  const operationName = /(query|mutation) ([a-zA-Z0-9]+)/.exec(query)[2];

  const body = {
    operationName,
    query: query,
    variables,
  };

  const headers = {
    "Content-Type": "application/json",
    "X-CORE-SITE": SITE,
  };

  if (token) {
    headers["Authorization"] = "Bearer " + token;
  }

  return fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
};
